<template>
  <agent-default>
    <div class="dashboard-body">
      <h2 class="c-navy-text tw-text-xl tw-font-bold tw-mb-6">
        <v-icon color="#1E4276" class="tw-mr-2">mdi-cog-outline</v-icon> Settings & KYC Profile
      </h2>

      <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-8">

        <!-- KYC Status Panel -->
        <div class="settings-card tw-flex tw-flex-col tw-items-center">
          <h3 class="tw-text-lg tw-font-bold c-navy-text tw-mb-6">KYC Status</h3>

          <div class="kyc-progress-container tw-mb-6">
            <v-progress-circular
              :rotate="-90"
              :size="160"
              :width="12"
              :value="40"
              color="#FFC107"
            >
              <span class="kyc-percentage">40%</span>
            </v-progress-circular>
          </div>

          <v-chip color="warning" label class="tw-mb-8 tw-font-bold">
            <v-icon small left>mdi-alert-circle-outline</v-icon>
            Action Required
          </v-chip>

          <div class="tw-w-full tw-space-y-4">
            <div class="kyc-item">
              <v-icon color="success" size="20">mdi-check-circle</v-icon>
              <span class="tw-flex-1 tw-text-sm">Basic Profile</span>
            </div>
            <div class="kyc-item">
              <v-icon color="success" size="20">mdi-check-circle</v-icon>
              <span class="tw-flex-1 tw-text-sm">KRA PIN Verified</span>
            </div>
            <div class="kyc-item">
              <v-icon color="warning" size="20">mdi-clock-outline</v-icon>
              <div class="tw-flex tw-flex-col">
                <span class="tw-text-sm">ID Document</span>
                <span class="tw-text-xs c-gray-text">Awaiting Upload</span>
              </div>
            </div>
            <div class="kyc-item">
              <v-icon color="warning" size="20">mdi-clock-outline</v-icon>
              <div class="tw-flex tw-flex-col">
                <span class="tw-text-sm">IRA License</span>
                <span class="tw-text-xs c-gray-text">Awaiting Upload</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Forms & Uploads -->
        <div class="lg:tw-col-span-2 tw-space-y-6">

          <!-- Personal Details -->
          <div class="settings-card">
            <h4 class="tw-text-md tw-font-bold c-navy-text tw-border-b tw-pb-2 tw-mb-6">
              Personal Details
            </h4>

            <v-row>
              <v-col cols="12" md="6">
                <label class="input-label">Full Name</label>
                <v-text-field
                  v-model="profile.name"
                  outlined
                  dense
                  hide-details
                  class="tw-mt-1"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <label class="input-label">Email Address</label>
                <v-text-field
                  v-model="profile.email"
                  outlined
                  dense
                  hide-details
                  class="tw-mt-1"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <label class="input-label">Phone Number</label>
                <v-text-field
                  v-model="profile.phone"
                  outlined
                  dense
                  hide-details
                  class="tw-mt-1"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <label class="input-label">KRA PIN</label>
                <v-text-field
                  v-model="profile.kra"
                  outlined
                  dense
                  hide-details
                  disabled
                  background-color="#f8fafc"
                  class="tw-mt-1"
                ></v-text-field>
              </v-col>
            </v-row>
            <div class="tw-mt-6">
              <v-btn color="primary" outlined @click="updateProfile">Update Profile</v-btn>
            </div>
          </div>

          <!-- KYC Documents -->
          <div class="settings-card">
            <div class="tw-flex tw-justify-between tw-items-center tw-border-b tw-pb-2 tw-mb-6">
              <h4 class="tw-text-md tw-font-bold c-navy-text">Pending KYC Documents</h4>
              <span class="tw-text-xs c-gray-text">Required for 100% completion</span>
            </div>

            <v-row>
              <v-col cols="12" md="6">
                <label class="input-label">National ID / Passport</label>
                <div class="mock-upload tw-mt-1">
                  <v-icon color="#64748B">mdi-cloud-upload-outline</v-icon>
                  <span class="tw-text-sm">Upload ID (Front & Back)</span>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <label class="input-label">Valid IRA License</label>
                <div class="mock-upload tw-mt-1">
                  <v-icon color="#64748B">mdi-file-outline</v-icon>
                  <span class="tw-text-sm">Upload PDF Document</span>
                </div>
              </v-col>
            </v-row>

            <div class="tw-flex tw-justify-end tw-mt-8">
              <v-btn
                color="primary"
                :loading="submitting"
                @click="submitKYC"
              >
                Submit Documents for Review
              </v-btn>
            </div>
          </div>

        </div>

      </div>
    </div>
  </agent-default>
</template>

<script>
import AgentDefault from '@/components/layout/AgentDefault';
import { trackAgentInteraction } from '@/utils/agentAnalytics';

export default {
  name: 'AgentSettings',
  components: {
    AgentDefault,
  },
  data() {
    return {
      submitting: false,
      profile: {
        name: 'John Doe',
        email: 'john.doe@pacis.com',
        phone: '+254 712 345 678',
        kra: 'A123456789Z',
      },
    };
  },
  methods: {
    updateProfile() {
      trackAgentInteraction(this, 'settings_update_profile_click');
      this.$toast.info('Profile update is not yet connected to backend', 'Info');
    },
    submitKYC() {
      trackAgentInteraction(this, 'settings_submit_kyc_click');
      this.submitting = true;
      setTimeout(() => {
        this.submitting = false;
        this.$toast.success('KYC documents submitted for review', 'Success');
      }, 1500);
    },
  },
  metaInfo: {
    title: 'Settings & KYC',
  },
};
</script>

<style scoped>
.settings-card {
  background: white;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

.kyc-percentage {
  font-size: 2.2rem;
  font-weight: 800;
  color: #1E4276;
}

.kyc-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #f1f5f9;
}

.input-label {
  font-size: 0.82rem;
  font-weight: 700;
  color: #1E4276;
}

.mock-upload {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 2px dashed #CBD5E1;
  border-radius: 10px;
  padding: 24px;
  background: #f8fafc;
  color: #64748B;
  cursor: pointer;
  transition: all 0.2s;
}

.mock-upload:hover {
  border-color: #00AEEF;
  background: #F0F9FF;
  color: #00AEEF;
}
</style>
